import React, { Fragment } from "react";
import TextAreaAutosize from "react-textarea-autosize";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import DynamicOptionList from "./dynamic-option-list";
import { get } from "./requests";
import ID from "./UUID";
import {
  getCalculation,
  getDiaryPage,
  getInputFieldTypeDataService,
  getPatientAttributeConfiguration,
  getQuestionaireId,
  getQuestionaireType,
  getQuestionaireTypeId,
  getSubmitActionParameters,
} from "../../../../../services/calculation";
import { getBusinessRules } from "../../../../../services/business-rules";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SettingsIcon from "@mui/icons-material/Settings";
import VisibilityIcon from "@mui/icons-material/Visibility";
import WorkIcon from "@mui/icons-material/Work";
import Box from "@mui/material/Box";
// import "./QuestionnaireCss.css";
import withNavigate from "./../../../../../utils/data";
import ManageChoicesList from "../ManageChoices/manageChoiceList";
import { TextField } from "@mui/material";
import MangeTranslation from "../FormBuilder/Translation/editTranslation";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Fragment>{children}</Fragment>
        </Box>
      )}
    </div>
  );
}
const toolbar = {
  options: [
    "inline",
    "list",
    "textAlign",
    "fontSize",
    "link",
    "history",
    "fontFamily",
  ],
  inline: {
    inDropdown: false,
    className: undefined,
    options: ["bold", "italic", "underline", "superscript", "subscript"],
  },
  fontFamily: {
    options: [
      "Roboto",
      "Helvetica",
      "Arial",
      "sans-serif",
      "Georgia",
      "Impact",
      "Tahoma",
      "Times New Roman",
      "Verdana",
    ],
    className: undefined,
    component: undefined,
    dropdownClassName: undefined,
  },
};
var id = location?.state?.id;
class FormElementsEdit extends React.Component {
  constructor(props, formId, questionId) {
    super(props);
    this.state = {
      isModalOpen: false,
      load: false,
      element: this.props.element,
      data: this.props.data,
      dirty: false,
      activeTab: 0,
      calculations: [],
      businessRules: [],
      filteredRules: [],
      diaryPageOptions: [],
      questionaireIdOptions: [],
      questionaireTypeOptions: [],
      LanguagesOptions: [],
      ChoiceDisplayOptions: [],
      PatientAttributeConfigurationOptions: [],
      SubmitActionParameterOptions: [],
      inputFieldTypeOptions: [],
      count: 0,
      selectedRuleName: "",
    };
    this.handleAddingDivs = this.handleAddingDivs.bind(this);
  }
  componentDidMount() {
    this.getCalculationData();
    this.getBusinessRulesData();
    this.getDiaryPageData();
    this.getQuestionaireTypeData();
    this.getQuestionaireIdData();
    this.getPatientAttributeConfigurationData();
    this.getSubmitActionParametersData();
    this.getInputFieldTypeData();
  }
  toggleRequired() {
    // const this_element = this.state.element;
  }

  handleAddingDivs() {
    this.setState({ count: this.state.count + 1 });
  }

  editElementProp(elemProperty, targProperty, e) {
    const this_element = this.state.element;

    if (elemProperty === "VisibleBusinessRuleId") {
      this_element[elemProperty] = e.target[targProperty];
    }
    if (elemProperty === "labelAlignment") {
      const newAlignment = e.target[targProperty];
      localStorage.setItem("labelAlignment", newAlignment);
      if (this.props.setAlignment) {
        this.props.setAlignment(newAlignment);
        this_element.props[elemProperty] = e.target[targProperty];
      }
    } else if (elemProperty === "VisibleBusinessRuleId") {
      this_element[elemProperty] = e.target[targProperty];
    } else {
      this_element[elemProperty] = e.target[targProperty];
    }

    this.setState(
      {
        ...this.state,
        element: this_element,
        dirty: true,
      },
      () => {
        if (targProperty === "checked") {
          this.updateElement();
        }
      }
    );
  }

  handleOpenModal = () => {
    const fieldId = this.props.element?.fieldId;
    const questionDataId = this.props.questionId;
    this.props.navigate("/study-management/manage-choices", {
      state: {
        fieldId: fieldId,
        questionDataId: questionDataId,
      },
    });
  };

  handleEditTranslation = () => {
    const fieldId = this.props.element?.fieldId;
    const questionDataId = this.props.questionId;
    this.props.navigate("/study-management/edit-translation", {
      state: {
        fieldId: fieldId,
        questionDataId: questionDataId,
      },
    });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleModalOpen = (status) => {
    this.setState({ isModalOpen: status });
  };

  getCalculationData = async () => {
    try {
      const res = await getCalculation();
      if (res.status) {
        this.setState({ calculations: res.data.result.calculationData });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getDiaryPageData = async () => {
    try {
      const res = await getDiaryPage(this.props.questionId);
      // console.log(res.data.result, "126");
      if (res.status) {
        this.setState({ diaryPageOptions: res.data.result });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getQuestionaireIdData = async () => {
    try {
      const res = await getQuestionaireId();
      // console.log(res.data.result, "143");
      if (res.status) {
        this.setState({
          questionaireIdOptions: res.data.result.allQuestionTypes,
        });
        this.setState({ LanguagesOptions: res.data.result.languageList });
        this.setState({
          ChoiceDisplayOptions: res.data.result.choiceDisplayTypesData,
        });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getQuestionaireTypeData = async () => {
    try {
      const res = await getQuestionaireType(this.props.questionId);
      if (res.status) {
        this.setState({
          questionaireTypeOptions: res.data.result.questionnaireType,
        });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getSubmitActionParametersData = async () => {
    try {
      const res = await getSubmitActionParameters(this.props.questionId);
      if (res.status) {
        this.setState({
          SubmitActionParameterOptions: res.data.result,
        });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getPatientAttributeConfigurationData = async () => {
    try {
      const res = await getPatientAttributeConfiguration();
      if (res.status) {
        this.setState({
          PatientAttributeConfigurationOptions: res.data.result,
        });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getBusinessRulesData = async () => {
    try {
      const res = await getBusinessRules();

      if (res.status) {
        this.setState({ businessRules: res.data.result });
      }
    } catch (err) {
      console.log("Error: ", err.message);
    }
  };

  getInputFieldTypeData = async () => {
    try {
      const res = await getInputFieldTypeDataService();
      if (res?.status) {
        this.setState({ inputFieldTypeOptions: res.data.result });
      }
    } catch (err) {}
  };

  updateActiveTab = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  editPropElement(elemProperty, targProperty, e) {
    // elemProperty could be content or label
    // targProperty could be value or checked
    const this_element = this.state.element;
    this_element.props[elemProperty] =
      e.target[targProperty] == "true" ? true : false;

    this.setState(
      {
        element: this_element,
        dirty: true,
      },
      () => {
        if (targProperty === "checked") {
          this.updateElement();
        }
      }
    );
  }

  onEditorStateChange(index, property, editorContent) {
    // const html = draftToHtml(convertToRaw(editorContent.getCurrentContent())).replace(/<p>/g, '<div>').replace(/<\/p>/g, '</div>');
    const html = draftToHtml(convertToRaw(editorContent.getCurrentContent()))
      .replace(/<p>/g, "")
      .replace(/<\/p>/g, "")
      .replace(/&nbsp;/g, " ")
      .replace(/(?:\r\n|\r|\n)/g, " ");
    const this_element = this.state.element;
    this_element.props[property] = html;

    this.setState({
      element: this_element,
      dirty: true,
    });
  }

  updateElement() {
    const this_element = this.state.element;
    // to prevent ajax calls with no change
    if (this.state.dirty) {
      this.props.updateElement.call(this.props.preview, this_element);
      this.setState({ dirty: false });
    }
  }

  alignmentOptions = [
    { value: "top", label: "Top" },
    { value: "right", label: "Right" },
    { value: "left", label: "Left" },
  ];

  convertFromHTML(content) {
    // Validate content
    if (!content || typeof content !== "string" || !content.trim()) {
      console.warn("Invalid content passed to convertFromHTML:", content);
      return EditorState.createEmpty();
    }

    const newContent = convertFromHTML(content);
    if (!newContent.contentBlocks || !newContent.contentBlocks.length) {
      // Prevent crash when no content blocks are found
      return EditorState.createEmpty();
    }

    const contentState = ContentState.createFromBlockArray(newContent);
    return EditorState.createWithContent(contentState);
  }

  filterRules(id) {
    let selectedRules = [];
    selectedRules.push(id);
    let filterArray = this.state.businessRules.filter((item) => item.id !== id);

    this.setState({ filteredRules: filterArray });
  }

  addOptions() {
    const optionsApiUrl = document.getElementById("optionsApiUrl").value;
    if (optionsApiUrl) {
      get(optionsApiUrl).then((data) => {
        this.props.element.options = [];
        const { options } = this.props.element;
        data.forEach((x) => {
          // eslint-disable-next-line no-param-reassign
          x.key = ID.uuid();
          options.push(x);
        });
        const this_element = this.state.element;
        this.setState({
          element: this_element,
          dirty: true,
        });
      });
    }
  }

  render() {
    const { isModalOpen } = this.state;
    if (this.state.dirty) {
      this.props.element.dirty = true;
    }
    const this_checked = this.props.element?.hasOwnProperty("required")
      ? this.props.element.required
      : false;
    const this_read_only = this.props.element?.hasOwnProperty("readOnly")
      ? this.props.element.readOnly
      : false;
    const this_default_today = this.props.element?.hasOwnProperty(
      "defaultToday"
    )
      ? this.props.element.defaultToday
      : false;
    const this_show_time_select = this.props.element?.hasOwnProperty(
      "showTimeSelect"
    )
      ? this.props.element.showTimeSelect
      : false;
    const this_show_time_select_only = this.props.element?.hasOwnProperty(
      "showTimeSelectOnly"
    )
      ? this.props.element.showTimeSelectOnly
      : false;
    const this_checked_inline = this.props.element?.hasOwnProperty("inline")
      ? this.props.element.inline
      : false;
    const this_checked_bold = this.props.element?.hasOwnProperty("bold")
      ? this.props.element.bold
      : false;
    const this_checked_italic = this.props.element?.hasOwnProperty("italic")
      ? this.props.element.italic
      : false;
    const this_checked_center = this.props.element?.hasOwnProperty("center")
      ? this.props.element.center
      : false;
    const this_checked_page_break = this.props.element?.hasOwnProperty(
      "pageBreakBefore"
    )
      ? this.props.element.pageBreakBefore
      : false;
    const this_checked_alternate_form = this.props.element?.hasOwnProperty(
      "alternateForm"
    )
      ? this.props.element.alternateForm
      : false;
    const this_active_check = this.props.element?.hasOwnProperty("isActive")
      ? this.props.element.isActive
      : false;
    const this_auto_resize_check = this.props.element?.hasOwnProperty(
      "autoResizeChoices"
    )
      ? this.props.element.autoResizeChoices
      : false;
    const this_keep_question_text_fixed = this.props.element?.hasOwnProperty(
      "KeepQuestionTextFixed"
    )
      ? this.props.element.KeepQuestionTextFixed
      : false;
    const this_display_on_conf = this.props.element?.hasOwnProperty(
      "DisplayOnConfirmation"
    )
      ? this.props.element.DisplayOnConfirmation
      : false;
    const this_is_instruction = this.props.element?.hasOwnProperty(
      "IsInstruction"
    )
      ? this.props.element.IsInstruction
      : false;
    const land_scape_orientation = this.props.element?.hasOwnProperty(
      "IsLandscapeOrientation"
    )
      ? this.props.element.IsLandscapeOrientation
      : false;

    const is_blinded = this.props?.element?.hasOwnProperty("IsBlinded")
      ? this.props.element.IsBlinded
      : false;

    const is_handwriting_enabled = this.props?.element?.hasOwnProperty(
      "isHandWritingEnabled"
    )
      ? this.props.element.isHandWritingEnabled
      : false;

    const is_scroll_for_more = this.props?.element?.hasOwnProperty(
      "isScrollForMoreEnabled"
    )
      ? this.props.element.isScrollForMoreEnabled
      : false;

    const is_display_summary = this.props?.element?.hasOwnProperty(
      "DisplaySummaryScore"
    )
      ? this.props.element.DisplaySummaryScore
      : false;

    const is_drop_down_navigation = this.props?.element?.hasOwnProperty(
      "IsDropdownNavigationEnabled"
    )
      ? this.props.element.IsDropdownNavigationEnabled
      : false;

    const validate_question_on_save = this.props?.element?.hasOwnProperty(
      "ValidateQuestionnaireOnSave"
    )
      ? this.props.element.ValidateQuestionnaireOnSave
      : false;

    const prompt_incomplete = this.props?.element?.hasOwnProperty(
      "PromptIncompletePagesOnSave"
    )
      ? this.props.element.PromptIncompletePagesOnSave
      : false;

    const enforce_previous_days = this.props?.element?.hasOwnProperty(
      "EnforcePreviousDaysEntry"
    )
      ? this.props.element.EnforcePreviousDaysEntry
      : false;

    const allow_edit = this.props?.element?.hasOwnProperty("AllowEdit")
      ? this.props.element.AllowEdit
      : false;

    const {
      canHavePageBreakBefore,
      canHaveAlternateForm,
      canHaveDisplayHorizontal,
      canHaveOptionCorrect,
      canHaveOptionValue,
    } = this.props.element;

    const this_files = this.props.files.length ? this.props.files : [];
    if (
      this_files.length < 1 ||
      (this_files.length > 0 && this_files[0].id !== "")
    ) {
      this_files.unshift({ id: "", file_name: "" });
    }

    let editorState;
    if (this.props.element?.hasOwnProperty("content")) {
      editorState = this.convertFromHTML(this.props.element.props.content);
    }
    if (this.props.element?.hasOwnProperty("label")) {
      editorState = this.convertFromHTML(this.props.element.props.label);
    }
    if (this.props.element?.selectionOptions) {
      editorState = this.convertFromHTML(this.props.element.selectionOptions);
    }
    if (this.props.element?.questions) {
      editorState = this.convertFromHTML(this.props.element.questions);
    }

    let count = this.state.count;

    return (
      <div>
        <div className="flex justify-between items-center">
          <Tabs
            value={this.state.activeTab}
            onChange={this.updateActiveTab}
            aria-label="disabled tabs example"
            className="tabMinHeight"
          >
            <Tab
              icon={<SettingsIcon />}
              iconPosition="start"
              label="Settings"
            />
            <Tab
              label="Control Options"
              icon={<VisibilityIcon />}
              iconPosition="start"
            />
            {/* <Tab label="Properties" icon={<WorkIcon />} iconPosition="start" /> */}
          </Tabs>
          <div className="clearfix cursor-pointer">
            <i
              className="float-right fas fa-times"
              onClick={this.props.manualEditModeOff}
            ></i>
          </div>
        </div>
        <TabPanel value={this.state.activeTab} index={0}>
          {this.props.element.key === "PageBreak" && (
            <>
              <div className="form-group">
                <label className="control-label" htmlFor="PageId">
                  Page Id
                </label>
                <input
                  disabled={true}
                  id="PageId"
                  type="text"
                  className="form-control"
                  // defaultValue={this.props.element.id || ""}
                  value={this.props.element.id || ""}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "PageId", "value")}
                />
              </div>
              <br />

              <div className="form-group">
                <label className="control-label" htmlFor="PageId">
                  Name
                </label>
                <input
                  // disabled={true}
                  id="name"
                  type="text"
                  className="form-control"
                  // defaultValue={this.props.element?.text}
                  value={this.props.element?.name || ""}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "name", "value")}
                />
              </div>

              <br />

              <div className="form-group">
                <label className="control-label" htmlFor="PageId">
                  Number
                </label>
                <input
                  // disabled={true}
                  min={1}
                  id="number"
                  type="text"
                  className="form-control"
                  value={this?.props?.element?.number}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "number", "value")}
                />
              </div>

              <br />

              <div className="form-group">
                <label className="control-label" htmlFor="FooterText">
                  Footer Text
                </label>
                <input
                  // disabled={true}
                  id="footerText"
                  type="text"
                  className="form-control"
                  value={this.props.element?.footerText}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "footerText",
                    "value"
                  )}
                />
              </div>
              <br />

              <div className="form-group">
                <div className="custom-control custom-checkbox">
                  <input
                    id="isHandWritingEnabled"
                    className="custom-control-input"
                    type="checkbox"
                    checked={is_handwriting_enabled}
                    // value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "isHandWritingEnabled",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="isHandWritingEnabled"
                  >
                    Is HandWriting Enabled
                  </label>
                </div>
              </div>
              <br />
              <div className="form-group">
                <div className="custom-control custom-checkbox">
                  <input
                    id="isScrollForMoreEnabled"
                    className="custom-control-input"
                    type="checkbox"
                    checked={is_scroll_for_more}
                    // value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "isScrollForMoreEnabled",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="isScrollForMoreEnabled"
                  >
                    Is Scroll For More Enabled
                  </label>
                </div>
              </div>
            </>
          )}
          {this.props.element?.hasOwnProperty("content") && (
            <div className="form-group">
              <label className="control-label">Text to display:</label>

              <Editor
                toolbar={toolbar}
                editorState={editorState}
                defaultEditorState={editorState}
                onBlur={this.updateElement.bind(this)}
                onEditorStateChange={this.onEditorStateChange.bind(
                  this,
                  0,
                  "content"
                )}
                stripPastedStyles={true}
              />
            </div>
          )}
          {this.props.element?.hasOwnProperty("file_path") && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Choose file:
              </label>
              <select
                id="fileSelect"
                className="form-control"
                value={this.props.element.file_path}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "file_path", "value")}
              >
                {this_files.map((file) => {
                  const this_key = `file_${file.id}`;
                  return (
                    <option value={file.id} key={this_key}>
                      {file.file_name}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
          {this.props.element?.hasOwnProperty("href") && (
            <div className="form-group">
              <TextAreaAutosize
                type="text"
                className="form-control"
                value={this.props.element.href}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "href", "value")}
              />
            </div>
          )}
          {this.props.element?.hasOwnProperty("src") && (
            <div>
              <div className="form-group">
                <label className="control-label" htmlFor="srcInput">
                  Link to this :
                </label>
                <input
                  id="srcInput"
                  type="text"
                  className="form-control"
                  value={this.props.element.src}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "src", "value")}
                />
              </div>
              <div className="form-group">
                <div className="custom-control custom-checkbox">
                  <input
                    id="do-center"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_checked_center}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "center",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="do-center"
                  >
                    Center?
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <label className="control-label" htmlFor="elementWidth">
                    Width:
                  </label>
                  <input
                    id="elementWidth"
                    type="text"
                    className="form-control"
                    value={this.props.element.width}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(this, "width", "value")}
                  />
                </div>
                <div className="col-sm-3">
                  <label className="control-label" htmlFor="elementHeight">
                    Height:
                  </label>
                  <input
                    id="elementHeight"
                    type="text"
                    className="form-control"
                    value={this.props.element.height}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(
                      this,
                      "height",
                      "value"
                    )}
                  />
                </div>
              </div>
            </div>
          )}
          {this.props.element?.hasOwnProperty("label") && (
            <div className="form-group">
              <label>Display Label</label>
              <Editor
                toolbar={toolbar}
                // editorState={editorState}
                defaultEditorState={editorState}
                onBlur={this.updateElement.bind(this)}
                onEditorStateChange={this.onEditorStateChange.bind(
                  this,
                  0,
                  "label"
                )}
                stripPastedStyles={true}
              />
              <br />
              <div className="custom-control custom-checkbox">
                <input
                  // style={{ width: "100px", height: "100px" }}

                  id="is-required"
                  className="custom-control-input"
                  type="checkbox"
                  checked={this_checked}
                  value={true}
                  onChange={this.editElementProp.bind(
                    this,
                    "required",
                    "checked"
                  )}
                />
                <label
                  className="custom-control-label ml-2"
                  htmlFor="is-required"
                >
                  Required
                </label>
              </div>
              {this.props.element?.hasOwnProperty("readOnly") && (
                <div className="custom-control custom-checkbox">
                  <input
                    id="is-read-only"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_read_only}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "readOnly",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="is-read-only"
                  >
                    Read only
                  </label>
                </div>
              )}
              {this.props.element?.hasOwnProperty("defaultToday") && (
                <div className="custom-control custom-checkbox">
                  <input
                    id="is-default-to-today"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_default_today}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "defaultToday",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="is-default-to-today"
                  >
                    Default to Today?
                  </label>
                </div>
              )}
              {this.props.element?.hasOwnProperty("showTimeSelect") && (
                <div className="custom-control custom-checkbox">
                  <input
                    id="show-time-select"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_show_time_select}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "showTimeSelect",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="show-time-select"
                  >
                    Show Time Select?
                  </label>
                </div>
              )}
              {this_show_time_select &&
                this.props.element?.hasOwnProperty("showTimeSelectOnly") && (
                  <div className="custom-control custom-checkbox">
                    <input
                      id="show-time-select-only"
                      className="custom-control-input"
                      type="checkbox"
                      checked={this_show_time_select_only}
                      value={true}
                      onChange={this.editElementProp.bind(
                        this,
                        "showTimeSelectOnly",
                        "checked"
                      )}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="show-time-select-only"
                    >
                      Show Time Select Only?
                    </label>
                  </div>
                )}
              {(this.state.element.element === "RadioButtons" ||
                this.state.element.element === "Checkboxes") &&
                canHaveDisplayHorizontal && (
                  <div className="custom-control custom-checkbox">
                    <input
                      id="display-horizontal"
                      className="custom-control-input"
                      type="checkbox"
                      checked={this_checked_inline}
                      value={true}
                      onChange={this.editElementProp.bind(
                        this,
                        "inline",
                        "checked"
                      )}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="display-horizontal"
                    >
                      Display horizonal
                    </label>
                  </div>
                )}
            </div>
          )}
          {this.state.element.element === "Signature" &&
          this.props.element.readOnly ? (
            <div className="form-group">
              <label className="control-label" htmlFor="variableKey">
                Variable Key:
              </label>
              <input
                id="variableKey"
                type="text"
                className="form-control"
                value={this.props.element.variableKey}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "variableKey",
                  "value"
                )}
              />
              <p className="help-block">
                This will give the element a key that can be used to replace the
                content with a runtime value.
              </p>
            </div>
          ) : (
            <div />
          )}
          {this.props.element?.hasOwnProperty("step") && (
            <div className="form-group">
              <div className="form-group-range">
                <label className="control-label" htmlFor="rangeStep">
                  Step
                </label>
                <input
                  id="rangeStep"
                  type="number"
                  className="form-control"
                  value={this.props.element.step}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "step", "value")}
                />
              </div>
            </div>
          )}
          {this.props.element?.hasOwnProperty("min_value") && (
            <div className="form-group">
              <div className="form-group-range">
                <label className="control-label" htmlFor="rangeMin">
                  Min
                </label>
                <input
                  id="rangeMin"
                  type="number"
                  className="form-control"
                  value={this.props.element.min_value}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "min_value",
                    "value"
                  )}
                />
                <input
                  type="text"
                  className="form-control"
                  value={this.props.element.min_label}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "min_label",
                    "value"
                  )}
                />
              </div>
            </div>
          )}
          {this.props.element?.hasOwnProperty("max_value") && (
            <div className="form-group">
              <div className="form-group-range">
                <label className="control-label" htmlFor="rangeMax">
                  Max
                </label>
                <input
                  id="rangeMax"
                  type="number"
                  className="form-control"
                  value={this.props.element.max_value}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "max_value",
                    "value"
                  )}
                />
                <input
                  type="text"
                  className="form-control"
                  value={this.props.element.max_label}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "max_label",
                    "value"
                  )}
                />
              </div>
            </div>
          )}
          {this.props.element?.hasOwnProperty("default_value") && (
            <div className="form-group">
              <div className="form-group-range">
                <label className="control-label" htmlFor="defaultSelected">
                  Default Selected
                </label>
                <input
                  id="defaultSelected"
                  type="number"
                  className="form-control"
                  value={this.props.element.default_value}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "default_value",
                    "value"
                  )}
                />
              </div>
            </div>
          )}
          {this.props.element?.hasOwnProperty("static") &&
            this.props.element.static && (
              <div className="form-group">
                <label className="control-label">Text Style</label>
                <div className="custom-control custom-checkbox">
                  <input
                    id="do-bold"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_checked_bold}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "bold",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="do-bold"
                  >
                    Bold
                  </label>
                </div>
                <div className="custom-control custom-checkbox">
                  <input
                    id="do-italic"
                    className="custom-control-input"
                    type="checkbox"
                    checked={this_checked_italic}
                    value={true}
                    onChange={this.editElementProp.bind(
                      this,
                      "italic",
                      "checked"
                    )}
                  />
                  <label
                    className="custom-control-label ml-2"
                    htmlFor="do-italic"
                  >
                    Italic
                  </label>
                </div>
              </div>
            )}
          {this.props.element.showDescription && (
            <div className="form-group">
              <label className="control-label" htmlFor="questionDescription">
                Description
              </label>
              <TextAreaAutosize
                type="text"
                className="form-control"
                id="questionDescription"
                value={this.props.element.description}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "description",
                  "value"
                )}
              />
            </div>
          )}
          {(this.props.element.props?.show ||
            this.props.element.props?.show == false) && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Render ?
              </label>
              <select
                id="fileSelect"
                className="form-control"
                value={this.props.element.props.show}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editPropElement.bind(this, "show", "value")}
              >
                <option value={true} key={true}>
                  YES
                </option>
                <option value={false} key={false}>
                  NO
                </option>
              </select>
            </div>
          )}
          {/* <div className="form-group">
            <label className="control-label" htmlFor="fileSelect">
              Summary ?
            </label>
            <select
              id="fileSelect"
              className="form-control"
              defaultValue={this.props.element.summary || false}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(this, "summary", "value")}
            >
              <option value={true} key={true}>
                YES
              </option>
              <option value={false} key={false}>
                NO
              </option>
            </select>
          </div> */}
          {this.props.element.props?.hasOwnProperty("title") && (
            <div className="col-sm-3">
              <label className="control-label" htmlFor="elementHeight">
                Field Title
              </label>
              <input
                id="elementHeight"
                type="text"
                className="form-control"
                value={this.props.element.title}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "title", "value")}
              />
            </div>
          )}
          {/* for questions weight mainly for checkklist accident component */}
          {this.props.element.props?.hasOwnProperty("weight") && (
            <div className="col-sm-3">
              <label className="control-label" htmlFor="elementHeight">
                Question Weight (comma seperated)
              </label>
              <input
                id="elementHeight"
                type="text"
                className="form-control"
                value={this.props.element.weight}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "weight", "value")}
              />
            </div>
          )}
          {/* for adding the options in pill or multiselect */}
          {this.props.element.props?.selectionOptions && (
            <div className="form-group">
              <label className="control-label">
                Add elements with comma in between
              </label>

              <Editor
                toolbar={toolbar}
                defaultEditorState={editorState}
                onBlur={this.updateElement.bind(this)}
                onEditorStateChange={this.onEditorStateChange.bind(
                  this,
                  0,
                  "selectionOptions"
                )}
                stripPastedStyles={true}
              />
            </div>
          )}
          {this.props.element.props?.questions && (
            <div className="form-group">
              <label className="control-label">Add Questions</label>

              <Editor
                toolbar={toolbar}
                defaultEditorState={editorState}
                onBlur={this.updateElement.bind(this)}
                onEditorStateChange={this.onEditorStateChange.bind(
                  this,
                  0,
                  "questions"
                )}
                stripPastedStyles={true}
              />
            </div>
          )}
          {/* for adding the extra steps in form */}
          {(this.props.element.props?.hasNestedSteps == true ||
            this.props.element.props?.hasNestedSteps == false) && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Has Additional Steps ?
              </label>
              <select
                id="fileSelect"
                className="form-control"
                value={this.props.element.hasNestedSteps || false}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "hasNestedSteps",
                  "value"
                )}
              >
                <option value={true} key={true}>
                  YES
                </option>
                <option value={false} key={false}>
                  NO
                </option>
              </select>
            </div>
          )}
          {/* for the configuration of extra steps in form */}
          {(this.props.element.props?.isNestedStep == true ||
            this.props.element.props?.isNestedStep == false) && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                is Additional Step ?
              </label>
              <select
                className="form-control"
                value={this.props.element.isNestedStep || false}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "isNestedStep",
                  "value"
                )}
              >
                <option value={true} key={true}>
                  YES
                </option>
                <option value={false} key={false}>
                  NO
                </option>
              </select>
            </div>
          )}
          {/* for the configuration of extra steps in form */}
          {this.props.element.isNestedStep == "true" && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Parent page?
              </label>
              <input
                id="parentPage"
                type="number"
                className="form-control"
                value={this.props.element.parentStep || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "parentStep",
                  "value"
                )}
              />
            </div>
          )}
          {/* for the configuration of extra steps in form */}
          {this.props.element.isNestedStep == "true" && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Parent page field title?
              </label>
              <input
                id="parentOption"
                type="text"
                className="form-control"
                value={this.props.element.parentTitle || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "parentTitle",
                  "value"
                )}
              />
            </div>
          )}
          {this.props.element.isNestedStep == "true" && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Parent page option?
              </label>
              <input
                id="parentOption"
                type="text"
                className="form-control"
                value={this.props.element.parentValue || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "parentValue",
                  "value"
                )}
              />
            </div>
          )}
          {this.props.showCorrectColumn &&
            this.props.element.canHaveAnswer &&
            !this.props.element?.hasOwnProperty("options") && (
              <div className="form-group">
                <label className="control-label" htmlFor="correctAnswer">
                  Correct Answer
                </label>
                <input
                  id="correctAnswer"
                  type="text"
                  className="form-control"
                  value={this.props.element.correct}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "correct", "value")}
                />
              </div>
            )}
          {this.props.element.canPopulateFromApi &&
            this.props.element?.hasOwnProperty("options") && (
              <div className="form-group">
                <label className="control-label" htmlFor="optionsApiUrl">
                  Populate Options from API
                </label>
                <div className="row">
                  <div className="col-sm-6">
                    <input
                      className="form-control"
                      style={{ width: "100%" }}
                      type="text"
                      id="optionsApiUrl"
                      placeholder="http://localhost:8080/api/optionsdata"
                    />
                  </div>
                  <div className="col-sm-6">
                    <button
                      onClick={this.addOptions.bind(this)}
                      className="btn btn-success"
                    >
                      Populate
                    </button>
                  </div>
                </div>
              </div>
            )}
          {this.props.element?.hasOwnProperty("options") && (
            <DynamicOptionList
              showCorrectColumn={this.props.showCorrectColumn}
              canHaveOptionCorrect={canHaveOptionCorrect}
              canHaveOptionValue={canHaveOptionValue}
              data={this.props.preview.state.data}
              updateElement={this.props.updateElement}
              preview={this.props.preview}
              element={this.props.element}
              key={this.props.element.options.length}
            />
          )}
          {/* for title */}
          {this.props.element.props?.hasDropDown === true && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Do you want to add dropdown options?
              </label>
              <select
                className="form-control"
                value={this.props.element.hasPageTitle || false}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "hasPageTitle",
                  "value"
                )}
              >
                <option value={true} key={true}>
                  YES
                </option>
                <option value={false} key={false}>
                  NO
                </option>
              </select>
            </div>
          )}
          {this.props.element.props?.hasOwnProperty("imgLink") && (
            <div>
              <label className="control-label" htmlFor="elementHeight">
                Img Link
              </label>
              <input
                id="elementHeight"
                type="text"
                className="form-control"
                value={this.props.element.imgLink}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "imgLink", "value")}
              />
            </div>
          )}
          {/* when page title has to be added to a field */}
          {this.props.element.hasPageTitle == "true" && (
            <div className="form-group">
              <label className="control-label" htmlFor="fileSelect">
                Dropdown options (Comma Seperated)
              </label>
              <textarea
                id="parentOption"
                type="text"
                rows={5}
                className="form-control"
                value={this.props.element.pageTitle || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "pageTitle", "value")}
              ></textarea>
              {/* <input
              id="parentOption"
              type="text"
              className="form-control"
              defaultValue={this.props.element.pageTitle || ""}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(this, "pageTitle", "value")}
            /> */}
            </div>
          )}
          <div className="form-group">
            <label className="control-label" htmlFor="QuestionnaireId">
              Questionnaire Id
            </label>
            <select
              disabled={true}
              id="QuestionnaireId"
              className="form-control"
              value={`TranslationKey-${this.props?.questionId}`}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "QuestionnaireId",
                "value"
              )}
            >
              <option value={"TranslationKey"} key={"TranslationKey"}>
                {`TranslationKey-${this.props?.questionId}`}
              </option>
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="DiaryPageId">
              Diary Page
            </label>
            <select
              id="DiaryPageId"
              className="form-control"
              placeholder="Select a DiaryPage"
              value={this.props?.element.DiaryPage}
              // defaultValue={this.props.element.DiaryPage || ""}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(this, "DiaryPage", "value")}
            >
              <option value="" key={"Default"}>
                Select a DiaryPage
              </option>

              {this.state?.diaryPageOptions?.map((item, index) => {
                return (
                  <option value={item.value} key={item.value}>
                    {index + 1 + ". " + item.text}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="InputFieldTypeId">
              Input Field Type
            </label>
            <select
              id="InputFieldTypeId"
              className="form-control"
              value={this.props?.element.InputFieldTypeId || "None"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "InputFieldTypeId",
                "value"
              )}
            >
              {Object.entries(this.state?.inputFieldTypeOptions || {}).map(
                ([key, value]) => (
                  <option key={value} value={value}>
                    {key}
                  </option>
                )
              )}
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="QuestionTypeId">
              Question Type
            </label>
            {/* {console.log(this.props?.element, "1496")} */}
            <select
              id="QuestionTypeId"
              className="form-control"
              // defaultValue={"None"}
              value={this.props?.element.QuestionTypeId || "None"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "QuestionTypeId",
                "value"
              )}
            >
              <option value={"Default"} key={"Default"}>
                Default
              </option>
              {this.state?.questionaireIdOptions?.map((item, index) => {
                return (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
          LanguagesOptions
          <div className="form-group">
            <label className="control-label" htmlFor="QuestionTranslationKey">
              Question Translation Key
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  value={`TranslationKey-${this.props?.element?.id}`}
                  disabled={true}
                  id="QuestionTranslationKey"
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  onChange={this.editElementProp.bind(
                    this,
                    "QuestionTranslationKey",
                    "value"
                  )}
                  onBlur={this.updateElement.bind(this)}
                  // placeholder="http://localhost:8080/api/optionsdata"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="ExportDisplayName">
              Export Display Name
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="ExportDisplayName"
                  value={this.props?.element.ExportDisplayName}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "ExportDisplayName",
                    "value"
                  )}
                  // placeholder="http://localhost:8080/api/optionsdata"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="ExportDisplayOrder">
              Export Display Order
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  id="ExportDisplayOrder"
                  value={this.props?.element.ExportDisplayOrder}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "ExportDisplayOrder",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SASDataTypeId">
              SAS Data Type
            </label>
            <select
              id="SASDataTypeId"
              className="form-control"
              // defaultValue={"None"}
              value={this.props?.element.SASDataTypeId || "None"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "SASDataTypeId",
                "value"
              )}
            >
              <option value={"INTEGER"} key={"INTEGER"}>
                INTEGER
              </option>
              <option value={"STRING"} key={"STRING"}>
                STRING
              </option>
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SASLabel">
              SAS Label
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="SASLabel"
                  value={this.props?.element.SASLabel}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "SASLabel",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SDTMCode">
              SDTM Code
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  id="SDTMCode"
                  value={this.props?.element.SDTMCode}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "SDTMCode",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SDTMText">
              SDTM Text
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="SDTMText"
                  value={this.props?.element.SDTMText}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "SDTMText",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SummaryDisplayTextKey">
              Summary Display Text Key
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  value={`TranslationKey-${this.props.element.id}SummaryText`}
                  disabled={true}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="SummaryDisplayTextKey"
                  // placeholder="http://localhost:8080/api/optionsdata"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SummaryDisplayText">
              Summary Display Text
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="SummaryDisplayText"
                  value={this.props?.element.SummaryDisplayText}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "SummaryDisplayText",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="Description">
              Description
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="Description"
                  value={this.props?.element.Description}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "Description",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="Sequence">
              Sequence (This is used to order questionnaires on handheld that
              are NOT associate with a Visit):
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  id="Sequence"
                  value={this.props?.element.Sequence}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "Sequence",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="GroupNumber">
              Group Number
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  value={this.props?.element.GroupNumber}
                  type="text"
                  id="GroupNumber"
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "GroupNumber",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              id="isActive"
              className="custom-control-input"
              type="checkbox"
              checked={this_active_check}
              value={true}
              onChange={this.editElementProp.bind(this, "isActive", "checked")}
            />
            <label className="custom-control-label ml-2" htmlFor="isActive">
              Active
            </label>
          </div>
          <br />
          <div className="form-group">
            <label
              className="control-label"
              htmlFor="PatientAttributeConfiguration"
            >
              Patient Attribute Configuration
            </label>
            <select
              id="PatientAttributeConfiguration"
              className="form-control"
              // defaultValue={"Attribute 1"}
              value={
                this.props?.element.PatientAttributeConfiguration ||
                "Attribute 1"
              }
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "PatientAttributeConfiguration",
                "value"
              )}
            >
              <option value={"Default"} key={"Default"}>
                Default
              </option>
              {this.state?.PatientAttributeConfigurationOptions?.map(
                (item, index) => {
                  return (
                    <option value={item.value} key={item.value}>
                      {index + 1 + ". " + item.text}
                    </option>
                  );
                }
              )}
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="SubmitActionParameter">
              Submit Action Parameter
            </label>
            <select
              id="SubmitActionParameter"
              className="form-control"
              // defaultValue={"Action 1"}
              value={this.props?.element.SubmitActionParameter || "Action 1"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "SubmitActionParameter",
                "value"
              )}
            >
              <option value={"Default"} key={"Default"}>
                Select action Parameters
              </option>
              {this.state?.SubmitActionParameterOptions?.map((item, index) => {
                return (
                  <option value={item.value} key={item.value}>
                    {index + 1 + ". " + item.text}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              id="autoResizeChoices"
              className="custom-control-input"
              type="checkbox"
              checked={this_auto_resize_check}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "autoResizeChoices",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="autoResizeChoices"
            >
              Auto Resize Choices
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="KeepQuestionTextFixed"
              className="custom-control-input"
              type="checkbox"
              checked={this_keep_question_text_fixed}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "KeepQuestionTextFixed",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="KeepQuestionTextFixed"
            >
              Keep Question Text Fixed on the screen
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="DisplayOnConfirmation"
              className="custom-control-input"
              type="checkbox"
              checked={this_display_on_conf}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "DisplayOnConfirmation",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="DisplayOnConfirmation"
            >
              Display On Confirmation
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="IsInstruction"
              className="custom-control-input"
              type="checkbox"
              checked={this_is_instruction}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "IsInstruction",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="IsInstruction"
            >
              Is Instruction
            </label>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="Language">
              Language
            </label>
            <select
              id="Language"
              className="form-control"
              value={this.props?.element.Language || "English"}
              // defaultValue={"English"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(this, "Language", "value")}
            >
              {this.state?.LanguagesOptions?.map((item, index) => {
                return (
                  <option value={item.value} key={item.value}>
                    {index + 1 + ". " + item.text}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="StudyFileId">
              Study File
            </label>
            <select
              id="StudyFileId"
              className="form-control"
              value={this.props?.element.StudyFileId || "Study File"}
              // defaultValue={"Study File"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(this, "StudyFileId", "value")}
            >
              <option value={"Study File"} key={"Study File"}>
                Study File
              </option>
              <option value={"Study File 2"} key={"Study File 2"}>
                Study File 2
              </option>
              <option value={"Study File 3"} key={"Study File 3"}>
                Study File 3
              </option>
            </select>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="MinValueTextKey">
              Min Value Text Key
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  value={`TranslationKey-${this.props.element.id}MinText`}
                  disabled={true}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="MinValueTextKey"
                  // placeholder="http://localhost:8080/api/optionsdata"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="MinValueTextKey">
              Min Value Display Text
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  value={this.props?.element.MinValueTextKeyText}
                  type="text"
                  id="MinValueTextKeyText"
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "MinValueTextKeyText",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="MaxValueTextKey">
              Max Value Text Key
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  value={`TranslationKey-${this.props.element.id}MaxText`}
                  disabled={true}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="MaxValueTextKey"
                  // placeholder="http://localhost:8080/api/optionsdata"
                />
              </div>
            </div>
          </div>
          <div className="form-group">
            <label className="control-label" htmlFor="MaxValueDisplayText">
              Max Value Display Text
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  value={this.props?.element.MaxValueDisplayText}
                  type="text"
                  id="MaxValueDisplayText"
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "MaxValueDisplayText",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              id="IsLandscapeOrientation"
              className="custom-control-input"
              type="checkbox"
              checked={land_scape_orientation}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "IsLandscapeOrientation",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="IsLandscapeOrientation"
            >
              Land Scape Orientation
            </label>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="InputDisplayText">
              InputDisplayText
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  value={this.props?.element.InputDisplayText}
                  id="InputDisplayText"
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "InputDisplayText",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="Id">
              Id
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  value={`${this.props?.element?.id}`}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="Id"
                  disabled={true}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(this, "Id", "value")}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="TranslationKeyForEdit">
              Translation Key (Current translated value:)
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  value={this.props?.element.TranslationKeyForEdit}
                  id="TranslationKeyForEdit"
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "TranslationKeyForEdit",
                    "value"
                  )}
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "50%" }}
                  value="Edit Translation"
                  type="button"
                  id="EditTranslation"
                  onBlur={this.updateElement.bind(this)}
                  onClick={this.handleEditTranslation}
                  onChange={this.editElementProp.bind(
                    this,
                    "EditTranslation",
                    "value"
                  )}
                />
                {/* <MangeTranslation
                  isOpen={isModalOpen}
                  onClose={this.handleCloseModal}
                /> */}
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="InternalName">
              Internal Name
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  className="form-control"
                  style={{ width: "100%" }}
                  type="text"
                  id="InternalName"
                  value={this.props?.element.InternalName}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "InternalName",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="QuestionnaireTypeId">
              Questionnaire TypeId
            </label>
            <select
              id="Language"
              className="form-control"
              // defaultValue={"Clinician"}
              value={this.props?.element.QuestionnaireTypeId || "Clinician"}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "QuestionnaireTypeId",
                "value"
              )}
            >
              {this.state.questionaireTypeOptions && (
                <option value={this.state.questionaireTypeOptions.id}>
                  {`${this.state.questionaireTypeOptions.name}`}
                </option>
              )}
            </select>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="IsBlinded"
              className="custom-control-input"
              type="checkbox"
              checked={is_blinded}
              value={true}
              onChange={this.editElementProp.bind(this, "IsBlinded", "checked")}
            />
            <label className="custom-control-label ml-2" htmlFor="IsBlinded">
              Is Blinded
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="DisplaySummaryScore"
              className="custom-control-input"
              type="checkbox"
              checked={is_display_summary}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "DisplaySummaryScore",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="DisplaySummaryScore"
            >
              Display Summary Score
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="IsDropdownNavigationEnabled"
              className="custom-control-input"
              type="checkbox"
              checked={is_drop_down_navigation}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "IsDropdownNavigationEnabled",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="IsDropdownNavigationEnabled"
            >
              Is Dropdown Navigation Enabled
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="ValidateQuestionnaireOnSave"
              className="custom-control-input"
              type="checkbox"
              checked={validate_question_on_save}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "ValidateQuestionnaireOnSave",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="ValidateQuestionnaireOnSave"
            >
              Validate Questionnaire On Save
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="PromptIncompletePagesOnSave"
              className="custom-control-input"
              type="checkbox"
              checked={prompt_incomplete}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "PromptIncompletePagesOnSave",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="PromptIncompletePagesOnSave"
            >
              Prompt Incomplete Pages On Save
            </label>
          </div>
          <br />
          {/* <div style={{ background: "white", padding: "15px" }}> */}
          <div className="form-group">
            <label className="control-label" htmlFor="VisibleBusinessRuleId">
              Visible Business Rule Id
            </label>
            <select
              id="VisibleBusinessRuleId"
              className="form-control"
              value={this.props?.element.VisibleBusinessRuleId || ""}
              // defaultValue={this.props?.element?.VisibleBusinessRuleId}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "VisibleBusinessRuleId",
                "value"
              )}
            >
              <option value="" disabled>
                Select A Property
              </option>
              {/* {console.log(this.state.businessRules, this.props?.element?.EnableBusinessRuleId, this.props?.element?.VisibleBusinessRuleId, "2353")} */}

              {this.state.businessRules
                .filter(
                  (val) => val.id !== this.props?.element?.EnableBusinessRuleId
                )
                .map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
            </select>
          </div>
          {/* </div> */}
          <br />
          {/* <div style={{ background: "white", padding: "15px" }}> */}
          <div className="form-group">
            <label className="control-label" htmlFor="EnableBusinessRuleId">
              Enable Business Rule Id
            </label>
            <select
              id="EnableBusinessRuleId"
              className="form-control"
              value={this.props?.element.EnableBusinessRuleId || ""}
              // defaultValue={this.props?.element?.EnableBusinessRuleId}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "EnableBusinessRuleId",
                "value"
              )}
            >
              <option value="" disabled selected>
                Select A Property{" "}
              </option>
              {this.state.businessRules
                .filter(
                  (val) => val.id !== this.props?.element?.VisibleBusinessRuleId
                )
                .map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
            </select>
          </div>
          {/* </div> */}
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="OpenEndedBusinessRuleId">
              Open Ended Business Rule Id
            </label>
            <select
              id="OpenEndedBusinessRuleId"
              className="form-control"
              // defaultValue={""}
              value={this.props?.element.OpenEndedBusinessRuleId || ""}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "OpenEndedBusinessRuleId",
                "value"
              )}
            >
              <option value={""} key={""}>
                Select Option
              </option>
              <option value={"123"} key={"123"}>
                123
              </option>
              <option value={"ABC"} key={"ABC"}>
                ABC
              </option>
              <option value={"XYZ"} key={"XYZ"}>
                XYZ
              </option>
            </select>
          </div>
          <br />
          {/* <div style={{ background: "white", padding: "15px" }}> */}
          {/* <div className="form-group">
            <label className="control-label" htmlFor="VisibleBusinessRuleId">
              Visible Property
            </label>
            <select
              id="VisibleBusinessRuleId"
              className="form-control"
              defaultValue={this.props?.element?.VisibleBusinessRuleId}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "VisibleBusinessRuleId",
                "value"
              )}
            >
              <option value="" disabled selected>
                Select A Property
              </option>
              {this.state.businessRules
                .filter(
                  (val) => val.id !== this.props?.element?.EnableBusinessRuleId
                )
                .map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
            </select>
          </div> */}
          {/* </div> */}
          <br />
          {/* <div style={{ background: "white", padding: "15px" }}> */}
          {/* <div className="form-group">
            <label className="control-label" htmlFor="EnableBusinessRuleId">
              Enable Property
            </label>
            <select
              id="EnableBusinessRuleId"
              className="form-control"
              defaultValue={this.props?.element?.EnableBusinessRuleId}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "EnableBusinessRuleId",
                "value"
              )}
            >
              <option value="" disabled selected>
                Select A Property{" "}
              </option>
              {this.state.businessRules
                .filter(
                  (val) => val.id !== this.props?.element?.VisibleBusinessRuleId
                )
                .map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
            </select>
          </div> */}
          {/* </div> */}
          {this.props?.element.fieldId && (
            <>
              <div className="row">
                <div className="col-sm-12">
                  <button
                    className="form-control"
                    style={{ width: "50%" }}
                    value="Manage Choices"
                    type="button"
                    id="ManageChoices"
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(
                      this,
                      "ManageChoices",
                      "value"
                    )}
                    onClick={this.handleOpenModal}
                  >
                    Manage Choices
                  </button>
                </div>
              </div>
              <ManageChoicesList
                state={{
                  fieldId: this.props.element?.fieldId,
                  questionDataId: this.props.questionId,
                }}
              />
            </>
          )}
          {/*<ManageChoicesModal
          isOpen={isModalOpen}
          onClose={this.handleCloseModal}
        />*/}
          <br />
          {/* <div style={{ background: "white", padding: "15px" }}> */}
          <div className="form-group">
            <label className="control-label" htmlFor="ChoiceDisplayTypeId">
              Choice Display Property
            </label>
            <select
              id="ChoiceDisplayTypeId"
              className="form-control"
              value={this.props?.element.ChoiceDisplayTypeId || ""}
              // defaultValue={this.props?.element?.ChoiceDisplayTypeId }
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "ChoiceDisplayTypeId",
                "value"
              )}
            >
              <option value="" disabled selected>
                Select A Property
              </option>

              {this.state.ChoiceDisplayOptions?.map((item, index) => (
                <option value={item.value} key={item.value}>
                  {index + 1 + ". " + item.text}
                </option>
              ))}
            </select>
          </div>
          {/* </div> */}
          <br />
          <div className="form-group">
            <label
              className="control-label"
              htmlFor="EnableVisitQuestionnaireId"
            >
              Enable Visit Questionnaire Id (This diary will not be available
              until the specified Visit / Questionnaire is completed).
            </label>
            <select
              id="EnableVisitQuestionnaireId"
              className="form-control"
              value={this.props?.element.EnableVisitQuestionnaireId || ""}
              // defaultValue={""}
              onBlur={this.updateElement.bind(this)}
              onChange={this.editElementProp.bind(
                this,
                "EnableVisitQuestionnaireId",
                "value"
              )}
            >
              <option value={""} key={""}>
                Select Option
              </option>
              <option value={"123"} key={"123"}>
                123
              </option>
              <option value={"ABC"} key={"ABC"}>
                ABC
              </option>
              <option value={"XYZ"} key={"XYZ"}>
                XYZ
              </option>
            </select>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="PreviousDaysEntry">
              Previous Days Entry (This indicates how many days previous MUST be
              completed in the scale. 0 indicates just today. This would
              typically NOT have an available businessRule Id).
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  min={0}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  id="PreviousDaysEntry"
                  value={this.props?.element.PreviousDaysEntry}
                  // disabled={true}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "PreviousDaysEntry",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="form-group">
            <label className="control-label" htmlFor="PreviousDaysEdit">
              Previous Days Edit (This indicates how many days previous can be
              edited. 0 indicates just today. This would typically NOT have an
              available businessRule Id. It is directly related to the Previous
              Days Entry and would not typically be greater than that value).
            </label>
            <div className="row">
              <div className="col-sm-12">
                <input
                  min={0}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  id="PreviousDaysEdit"
                  value={this.props?.element.PreviousDaysEdit}
                  // disabled={true}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "PreviousDaysEdit",
                    "value"
                  )}
                />
              </div>
            </div>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="EnforcePreviousDaysEntry"
              className="custom-control-input"
              type="checkbox"
              checked={enforce_previous_days}
              value={true}
              onChange={this.editElementProp.bind(
                this,
                "EnforcePreviousDaysEntry",
                "checked"
              )}
            />
            <label
              className="custom-control-label ml-2"
              htmlFor="EnforcePreviousDaysEntry"
            >
              Enforce Previous Days Entry
            </label>
          </div>
          <br />
          <div className="custom-control custom-checkbox">
            <input
              id="AllowEdit"
              className="custom-control-input"
              type="checkbox"
              checked={allow_edit}
              value={true}
              onChange={this.editElementProp.bind(this, "AllowEdit", "checked")}
            />
            <label className="custom-control-label ml-2" htmlFor="AllowEdit">
              Allow Edit
            </label>
          </div>
          <br />
          <label htmlFor="submit-actions">Submit Actions:</label>
          <div className="form-group">
            <label htmlFor="first-select">Unassigned:</label>
            <select multiple className="form-control" id="first-select">
              <option disabled selected>
                Unassigned
              </option>
              <option>Subject Status Based initial Site Order</option>
              <option>Dispense Drug</option>
              <option>Create a Patient</option>
              <option>Assign Srata</option>
              <option>Randomize Patient</option>
              <option>Change Patient Status To Enrolled</option>
              <option>Randomize blocked by Site</option>
              <option>Randomize With Site Blocking</option>
              <option>Screen Fail</option>
              <option>Discontinue</option>
              <option>Dispense Drug With Titration</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="second-select">Assigned:</label>
            <select
              multiple
              className="form-control"
              id="second-select"
              disabled
              selected
            >
              <option>Assigned</option>
            </select>
          </div>
          <div className="text-3xl mb-1.5">Question Styles</div>
          <br />
          <div className="row">
            <div className="form-group col-md-6">
              <label className="control-label" htmlFor="width">
                Width <span className="text-sm">(max 360px)</span>
              </label>
              <div className="row">
                <div className="col-sm-12">
                  <input
                    className="form-control"
                    style={{ width: "100%" }}
                    type="number"
                    id="width"
                    value={this.props?.element.width || 230}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(this, "width", "value")}
                  />
                </div>
              </div>
            </div>
            <div className="form-group col-md-6">
              <label className="control-label" htmlFor="textSize">
                Text Size
              </label>
              <div className="row">
                <div className="col-sm-12">
                  <input
                    className="form-control"
                    style={{ width: "100%" }}
                    type="number"
                    id="textSize"
                    value={this.props?.element.textSize || 12}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(
                      this,
                      "textSize",
                      "value"
                    )}
                  />
                </div>
              </div>
            </div>
            {(this.props.element.key === "AgeRange" ||
              this.props.element.key === "Date" ||
              this.props.element.key === "TimeTwo" ||
              this.props.element.key === "NumericPad" ||
              this.props.element.key === "EQ5D5L" ||
              this.props.element.key === "DobAge" ||
              this.props.element.key === "Time" ||
              this.props.element.key === "AgeRangeYear" ||
              this.props.element.key === "VisitDatePicker") && (
              <>
                <div className="form-group col-md-6">
                  <label className="control-label" htmlFor="MinValue">
                    Minimum Value
                  </label>
                  <div className="row">
                    <div className="col-sm-12">
                      {this.props.element.key === "AgeRange" ||
                      this.props.element.key === "Date" ||
                      this.props.element.key === "EQ5D5L" ||
                      this.props.element.key === "VisitDatePicker" ? (
                        <TextField
                          placeholder="Min Value"
                          className="mx-5 px-2"
                          style={{ width: "100%", backgroundColor: "white" }}
                          type="date"
                          id="MinValue"
                          value={this.props?.element.MinValue}
                          onBlur={this.updateElement.bind(this)}
                          onChange={this.editElementProp.bind(
                            this,
                            "MinValue",
                            "value"
                          )}
                        />
                      ) : (
                        <input
                          className="form-control"
                          style={{ width: "100%" }}
                          type="number"
                          id="MinValue"
                          value={this.props?.element.MinValue}
                          onBlur={this.updateElement.bind(this)}
                          onChange={this.editElementProp.bind(
                            this,
                            "MinValue",
                            "value"
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group col-md-6">
                  <label className="control-label" htmlFor="MaxValue">
                    Maximum Value
                  </label>
                  <div className="row">
                    <div className="col-sm-12">
                      {this.props.element.key === "AgeRange" ||
                      this.props.element.key === "Date" ||
                      this.props.element.key === "EQ5D5L" ||
                      this.props.element.key === "VisitDatePicker" ? (
                        <TextField
                          className="mx-5 px-2"
                          style={{ width: "100%", backgroundColor: "white" }}
                          placeholder="Max Value"
                          type="date"
                          id="MaxValue"
                          value={this.props?.element.MaxValue}
                          onBlur={this.updateElement.bind(this)}
                          onChange={this.editElementProp.bind(
                            this,
                            "MaxValue",
                            "value"
                          )}
                        />
                      ) : (
                        <input
                          className="form-control"
                          style={{ width: "100%" }}
                          type="number"
                          id="MaxValue"
                          value={this.props?.element.MaxValue}
                          onBlur={this.updateElement.bind(this)}
                          onChange={this.editElementProp.bind(
                            this,
                            "MaxValue",
                            "value"
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {console.log(
              this.props?.element.labelAlignment,
              this.props?.alignment,
              "2915"
            )}
            <div className="form-group col-md-12">
              <label className="control-label" htmlFor="labelAlignment">
                Label Alignment
              </label>
              <select
                id="labelAlignment"
                className="form-control"
                value={this.props?.alignment}
                onClick={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(
                  this,
                  "labelAlignment",
                  "value"
                )}
              >
                {this.alignmentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group col-md-12">
              <label className="control-label" htmlFor="subLabel">
                Sub Label
              </label>
              <input
                className="form-control"
                style={{ width: "100%" }}
                type="text"
                id="subLabel"
                value={this.props?.element.subLabel}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "subLabel", "value")}
              />
            </div>
          </div>
          <br />
          <br />
        </TabPanel>
        <TabPanel value={this.state.activeTab} index={1}>
          <div style={{ background: "white", padding: "15px" }}>
            <div className="form-group">
              <div className="custom-control custom-checkbox">
                <input
                  id="useCalculation"
                  className="custom-control-input"
                  type="checkbox"
                  checked={this.props.element.useCalculation}
                  value={this.props.element.useCalculation}
                  onChange={this.editElementProp.bind(
                    this,
                    "useCalculation",
                    "checked"
                  )}
                />
                <label
                  className="custom-control-label ml-2"
                  htmlFor="useCalculation"
                >
                  Select from Calculations ?
                </label>
              </div>
            </div>

            {!!!this.props.element.useCalculation ? (
              <>
                <div className="form-group">
                  <label className="control-label" htmlFor="depends_on">
                    If
                  </label>
                  <select
                    id="depends_on"
                    className="form-control"
                    placeholder="Select a dependant components"
                    value={this.props.element.dependsOn || ""}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(
                      this,
                      "dependsOn",
                      "value"
                    )}
                  >
                    <option value="" disabled selected>
                      Select a dependant components
                    </option>

                    {this.props?.formData?.map((formElement, index) => {
                      if (this.props.element.id != formElement.id) {
                        return (
                          <option value={formElement.id} key={formElement.id}>
                            {index + 1 + ". " + formElement.text}
                          </option>
                        );
                      }
                    })}
                  </select>
                </div>
                <div className="form-group">
                  <label className="control-label" htmlFor="hasCondition">
                    Condition
                  </label>
                  <select
                    id="hasCondition"
                    className="form-control"
                    placeholder="Select a value for parent components"
                    value={this.props.element.hasCondition || ""}
                    onBlur={this.updateElement.bind(this)}
                    onChange={this.editElementProp.bind(
                      this,
                      "hasCondition",
                      "value"
                    )}
                  >
                    <option value="" disabled selected>
                      Select a condition
                    </option>

                    <option value={"=="} key={"eq"}>
                      {"equal ="}
                    </option>
                    <option value={"<"} key={"le"}>
                      {"Less Than <"}
                    </option>
                    <option value={">"} key={"gt"}>
                      {"Greater Than >"}
                    </option>
                    <option value={"<="} key={"le-eq"}>
                      {"Less Than and equal  <="}
                    </option>
                    <option value={">="} key={"gt-eq"}>
                      {"Greater Than and equal >="}
                    </option>
                  </select>
                </div>
              </>
            ) : (
              <div className="form-group">
                <label className="control-label" htmlFor="calculation">
                  Calculation
                </label>
                <select
                  id="calculation"
                  className="form-control"
                  placeholder="Select a Calculation"
                  value={this.props.element.calculation || ""}
                  onBlur={this.updateElement.bind(this)}
                  onChange={this.editElementProp.bind(
                    this,
                    "calculation",
                    "value"
                  )}
                >
                  <option value="" disabled selected>
                    Select a Calculation
                  </option>

                  {this.state?.calculations?.map((item, index) => {
                    return (
                      <option value={item.id} key={item.id}>
                        {index + 1 + ". " + item.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}
            <div className="form-group">
              <label className="control-label" htmlFor="hasValue">
                has Value
              </label>
              <input
                id="hasValue"
                className="form-control"
                placeholder="Select a value for parent components"
                value={this.props.element.hasValue || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "hasValue", "value")}
              ></input>
            </div>
          </div>

          <hr></hr>
          <div style={{ background: "white", padding: "15px" }}>
            <div className="form-group">
              <label className="control-label" htmlFor="rule_do">
                Do
              </label>
              <select
                id="rule_do"
                className="form-control"
                placeholder="Select a child component behaviour"
                value={this.props.element.doRule || ""}
                onBlur={this.updateElement.bind(this)}
                onChange={this.editElementProp.bind(this, "doRule", "value")}
              >
                <option value="" disabled selected>
                  Select a child component behaviour
                </option>

                <option value={true} key={true}>
                  Show
                </option>
                <option value={false} key={false}>
                  Hide
                </option>
                <option value={-1} key={-1}>
                  Disable
                </option>
              </select>
            </div>
          </div>
        </TabPanel>
      </div>
    );
  }
}
FormElementsEdit.defaultProps = { className: "edit-element-fields" };
export default withNavigate(FormElementsEdit);
